import { render } from "./ConfirmOrder.vue?vue&type=template&id=4e5d6c52&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=4e5d6c52&lang=scss&scoped=true"
import "./ConfirmOrder.vue?vue&type=style&index=1&id=4e5d6c52&lang=css"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5d6c52"]])

export default __exports__